export enum AreaType {
    default = 1,
    // layoutLinear = 2, // todo: unimplemented yet
    layout2D = 3,
}
